import { FC, SVGProps } from 'react'

export const SquareCreditCard: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.3501 7.48438H4.3501C3.79781 7.48438 3.3501 7.93209 3.3501 8.48438V24.4844C3.3501 25.0367 3.79781 25.4844 4.3501 25.4844H28.3501C28.9024 25.4844 29.3501 25.0367 29.3501 24.4844V8.48438C29.3501 7.93209 28.9024 7.48438 28.3501 7.48438Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3501 21.4844H25.3501"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3501 21.4844H17.3501"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.3501 12.5977H29.3501"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
